export default __webpack_public_path__ + "static/media/FAQ.1878de94.svg";